export const AUTO_SAVE_STATUS = Object.freeze({
  SAVING: 'Saving...',
  SAVED: 'Saved',
  UNSAVED: 'Unsaved Changes',
})
